var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stats-data-container"},[_c('StatsElectricChart'),_c('StatsEnergyEchart'),_c('StatsElectricTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }